var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses},[_c('div',{staticClass:"gc-progress-bar__bar gc-progress-bar__bar--filled",class:_vm.barClasses,style:(_vm.barStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }